import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Seo from "@/components/Seo";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MenuSection } from "@/components/MenuSection";
import { VisitSection } from "@/components/VisitSection";
import { Footer } from "@/components/Footer";

const restaurantJsonLd = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: "Northgate Flavour Express",
  servesCuisine: "Indian",
  telephone: "+61431264820",
  address: {
    "@type": "PostalAddress",
    streetAddress: "203 Toombul Rd",
    addressLocality: "Northgate",
    addressRegion: "QLD",
    postalCode: "4013",
    addressCountry: "AU",
  },
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Monday", opens: "11:30", closes: "20:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Tuesday", "Wednesday", "Thursday"], opens: "11:30", closes: "21:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Friday", opens: "15:00", closes: "22:30" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "15:00", closes: "22:00" },
  ],
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onAnchor);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-cream">
      <Seo
        title="Northgate Flavour Express — Indian Restaurant in Northgate, Brisbane"
        siteName="Northgate Flavour Express"
        description="Authentic Indian curries, tawa biryani and fresh naan at 203 Toombul Rd, Northgate QLD. Order online or reserve a table."
        image="/logo.jpg"
        jsonLd={restaurantJsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <MenuSection />
        <VisitSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
